/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Instant: { input: any; output: any; }
};

export type Author = {
  __typename?: 'Author';
  createdAt: Scalars['Instant']['output'];
  githubId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shaders: Array<Shader>;
};


export type AuthorShadersArgs = {
  childrenOf?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  publishShader: Shader;
  shareShader: Shader;
};


export type MutationPublishShaderArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  shader: Scalars['String']['input'];
};


export type MutationShareShaderArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  shader: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  shader?: Maybe<Shader>;
  shaders: Array<Shader>;
};


export type QueryShaderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShadersArgs = {
  authoredBy?: InputMaybe<Scalars['ID']['input']>;
  childrenOf?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Shader = {
  __typename?: 'Shader';
  author?: Maybe<Author>;
  body: Scalars['String']['output'];
  children: Array<Shader>;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  parent?: Maybe<Shader>;
};


export type ShaderChildrenArgs = {
  authoredBy?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ShaderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ShaderQuery = { __typename?: 'Query', shader?: { __typename?: 'Shader', body: string } | null };

export type ShareShaderMutationVariables = Exact<{
  shader: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ShareShaderMutation = { __typename?: 'Mutation', shareShader: { __typename?: 'Shader', id: string } };


export const ShaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Shader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shader"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]} as unknown as DocumentNode<ShaderQuery, ShaderQueryVariables>;
export const ShareShaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareShader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shader"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareShader"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shader"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shader"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ShareShaderMutation, ShareShaderMutationVariables>;